/**
 * PDP product-recommendations placement:
 * - Desktop: left column (gallery column), above description sink.
 * - Mobile: after trust panel (below title), before description.
 */
const DESKTOP_MQ = window.matchMedia('(min-width: 750px)');
const MOUNT_SELECTOR = '[data-product-recommendations-mount]';

/** @type {HTMLElement | null} */
let sectionHome = null;

/**
 * @returns {HTMLElement | null}
 */
function getRecommendationsSection() {
  const component = document.querySelector(
    'product-recommendations[data-testid="product-recommendations-section"]'
  );
  if (component) {
    const wrapper = component.closest('.shopify-section');
    if (wrapper instanceof HTMLElement) return wrapper;
  }

  return (
    document.querySelector('[id$="__product_recommendations_qggXJq"]') ??
    document.querySelector('[id$="product_recommendations_qggXJq"]')
  );
}

function getBuyButtonsBlock() {
  return document.querySelector('.product-details .buy-buttons-block');
}

function getMobileRecommendationsAnchor() {
  const detailsContent = document.querySelector('.product-details > .group-block > .group-block-content');
  if (!detailsContent) return null;

  const trust =
    detailsContent.querySelector(':scope > .pdp-buybox-trust-panel[data-pdp-mobile-trust-relocated]') ??
    detailsContent.querySelector(':scope > .pdp-buybox-trust-panel');

  if (trust instanceof HTMLElement) return trust;

  const title = detailsContent.querySelector(':scope > .text-block:has(h1)');
  if (title instanceof HTMLElement) return title;

  return getBuyButtonsBlock();
}

/**
 * @param {HTMLElement} section
 */
function rememberHome(section) {
  if (!sectionHome && section.parentElement) {
    sectionHome = section.parentElement;
  }
}

export function syncRecommendationsPlacement() {
  const section = getRecommendationsSection();
  if (!section) return false;

  rememberHome(section);

  if (DESKTOP_MQ.matches) {
    const mount = document.querySelector(MOUNT_SELECTOR);
    if (!mount) return false;

    if (section.parentElement !== mount) {
      mount.appendChild(section);
    }

    section.classList.add('product-recommendations--left-column');
    section.classList.remove('product-recommendations--mobile-after-buy');
    return true;
  }

  const anchor = getMobileRecommendationsAnchor();

  if (anchor) {
    if (anchor.nextElementSibling !== section) {
      anchor.after(section);
    }
  } else if (sectionHome) {
    sectionHome.appendChild(section);
  }

  section.classList.remove('product-recommendations--left-column');
  section.classList.add('product-recommendations--mobile-after-buy');
  return true;
}

function runPlacementPasses() {
  syncRecommendationsPlacement();
  requestAnimationFrame(syncRecommendationsPlacement);
  window.setTimeout(syncRecommendationsPlacement, 0);
  window.setTimeout(syncRecommendationsPlacement, 150);
}

document.addEventListener('DOMContentLoaded', runPlacementPasses);
DESKTOP_MQ.addEventListener('change', runPlacementPasses);
document.addEventListener('shopify:section:load', runPlacementPasses);
document.addEventListener('pdp-post-atc:synced', runPlacementPasses);
document.addEventListener('pdp-mobile-buybox:synced', runPlacementPasses);
window.addEventListener('pagereveal', runPlacementPasses);
window.addEventListener('pageshow', (event) => {
  if (event.persisted) runPlacementPasses();
});

let attempts = 0;
const retryTimer = window.setInterval(() => {
  attempts += 1;
  if (syncRecommendationsPlacement() || attempts >= 25) {
    window.clearInterval(retryTimer);
  }
}, 200);

if (document.readyState !== 'loading') {
  runPlacementPasses();
}
